<template>
<div id="rfc_consulta" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar RFCs de Consulta" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        
                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{update ? "Actualizar" : "Nuevo"}}
                                                RFC de Consulta</strong>
                                        </span>
                                    </v-card>                                    
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-autocomplete v-model="model.tipo_figura" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Figura" :rules="[rules.required]" >
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="rfc" label="RFC" type="text" @input="model.rfc = model.rfc.toUpperCase()" v-model="model.rfc" :rules="[rules.required, validaRfcUnico]" maxlength="25" ></v-text-field>
                                                </v-flex>                                                
                                            </v-layout>
                                            <v-row row wrap>
                                                <v-col sm="12" md="8" lg="8">
                                                    <v-text-field label="Nombre o Razón Social" type="text" v-model="model.nombre" :rules="[rules.required]" maxlength="350" ></v-text-field>
                                                </v-col> 
                                                <v-col sm="12" md="8" lg="8">
                                                    <v-text-field label="Primer Apellido" type="text" v-model="model.primer_apellido" maxlength="350" ></v-text-field>
                                                </v-col> 
                                                <v-col sm="12" md="8" lg="8">
                                                    <v-text-field label="Segundo Apellido" type="text" v-model="model.segundo_apellido" maxlength="350" ></v-text-field>
                                                </v-col>                                             
                                            </v-row>
                                                                                        
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="emisores.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="tipo_figura" slot-scope="props" >
                                    {{ get_tipo_figura(props.row.tipo_figura) }}
                                </template>
                                get_tipo_figura

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    components: {
    },
    data: () => ({
        tipos:[{
            "id": "TIPFIG.AGE",
            "text": "Agente Aduanal"
            }, {
            "id": "TIPFIG.EXP",
            "text": "Exportador"
            }, {
            "id": "TIPFIG.IMP",
            "text": "Importador"
            }, {
            "id": "TIPFIG.MAN",
            "text": "Mandatario"
        }],
        fab: false,
        name: "datagrid",
        importData: [],
        columns: ["rfc", "nombre", "primer_apellido", "segundo_apellido","tipo_figura", "actions"],
        show_loading: true,
        options: {
            filterable: ["rfc", "nombre", "primer_apellido", "segundo_apellido","tipo_figura"],
            sortable: ["rfc", "nombre", "primer_apellido", "segundo_apellido","tipo_figura"],

            headings: {
                rfc: "RFC",
                nombre: "Nombre o Razón Social",
                primer_apellido: "Primer Apellido",
                segundo_apellido: " Segundo Apellido",
                tipo_figura: "Tipo Figura",
                actions: "Operaciones"
            }
        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Catálogos",
                disabled: true,
                to: ""
            },
            {
                text: "RFCs Consulta",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        rfcupdate: "",        
        
        model: {            
            rfc: "",
            nombre: "",
            primer_apellido: "",
            segundo_apellido: "",
            tipo_figura: "",  
            cliente:"",                      
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            email: value => {
                if (value) {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Correo electrónico no valido";
                } else return true;
            },
            rfclen: v => (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres",
        },
        
        emisores: {
            selected: [],
            headers: [{
                    text: "RFC o TAX ID",
                    value: "rfc"
                },
                {
                    text: "Razón Social",
                    value: "razon_social"
                },
                {
                    text: "Contacto",
                    value: "nombre_contacto"
                },
                {
                    text: "Teléfono",
                    value: "telefono_contacto"
                },
                {
                    text: "Metadato",
                    value: "metadato"
                },
                {
                    text: "Operaciones",
                    value: "operaciones",
                    align: "center"
                }
            ],
            
            items: [],
            
        },
        
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.emisores.items;
            }

        },
    },
    methods: {
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo RFC Consulta";
                this.update = false;
            } else {
                this.title = "Actualizar RFC Consulta";
                this.update = true;
                this.rfcupdate = this.model.rfc;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.$local_storage.get("id_cliente");
        },
        get_tipo_figura: function(clave){
            var tipo_descripcion = "N/E";
            let tipo = this.tipos.find(e => e.id == clave);
            if(tipo){
                tipo_descripcion = tipo.text
            }
            return tipo_descripcion;
        },

        validaRfcUnico: function (rfc_value) {
            if (rfc_value!=null && rfc_value!=''){
                var rfcs = this.emisores.items.map(function (item) {
                    return item.rfc
                });
                var finder = rfcs.indexOf(rfc_value);

                if (finder != -1 && ((this.update == false) || (this.update == true && this.rfcupdate != rfc_value)))
                    return "El RFC ya ha sido ingresado";
                else
                    return true;
            } else
                return true;
        },        
        
        guardar() {
            const datos = this.model;
            
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;

                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id + "/";
                }
                
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        //console.log(error);                        
                        this.cargar();
                        this.$root.$dialogLoader.hide();                        
                    });
            }
        },

        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios
                .post(this.URL + "get_rfcs/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.emisores.items = res.data;                                                   
                    }
                })
                .catch(err => {
                   
                    console.log(err);                    
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;                    
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios.delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            //position: 'bottom-end',
                            //timer: 3000,
                            //showConfirmButton: false,
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                        this.$root.$dialogLoader.hide();
                    });
                }
                    
            });
        }, //delete
                    
                
    }, //methods
    created: function () {
        //this.URL = this.$hostname + "catalogos/rfc_consulta/";
        this.URL = "http://127.0.0.1:7000/catalogos/rfc_consulta/";        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();        
    }
};
</script>
